import { MnemonicState } from './states/mnemonic.state';
import { MnemonicDashboardState } from './states/mnemonic-dashboard.state';

export const mnemonicState = [MnemonicState, MnemonicDashboardState];
